import { createContext } from "react";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import { DEFAULT_FUNCTION, DEFAULT_QUERY } from "../../utils/helpers/constants";
import { ISkipReasonQuery } from "../../models/skip-reason/query";
import {
  ISkipReason,
  ISkipReasonDetails,
} from "../../models/skip-reason/response";
import {
  ICreateSkipReason,
  IUpdateSkipReason,
} from "../../models/skip-reason/request";

export type SkipReasonLoading =
  | "list"
  | "details"
  | "create"
  | "update"
  | "delete";

export interface IInternalState {
  loading: SkipReasonLoading[];

  list?: IBaseListingResponse<ISkipReason>;
  query: ISkipReasonQuery;

  details?: ISkipReasonDetails;
}

export const internalState: IInternalState = {
  loading: [],
  query: DEFAULT_QUERY,
};

export interface IExternalState extends IInternalState {
  actions: {
    getData: () => void;
    getDetails: (id: number) => void;
    setDetails: (data?: ISkipReason) => void;

    createSkipReason: (request: ICreateSkipReason) => void;
    updateSkipReason: (id: number, request: IUpdateSkipReason) => void;
    deleteSkipReason: (id: number) => void;
    exportExcel: (data: any) => any;

    setSearch: (search?: string) => void;
    setQuery: (query: ISkipReasonQuery) => void;
  };
}

export const externalState: IExternalState = {
  ...internalState,
  actions: {
    getData: DEFAULT_FUNCTION,
    getDetails: DEFAULT_FUNCTION,
    setDetails: DEFAULT_FUNCTION,
    exportExcel: DEFAULT_FUNCTION,

    createSkipReason: DEFAULT_FUNCTION,
    updateSkipReason: DEFAULT_FUNCTION,
    deleteSkipReason: DEFAULT_FUNCTION,

    setSearch: DEFAULT_FUNCTION,
    setQuery: DEFAULT_FUNCTION,
  },
};

const SkipReasonContext = createContext(externalState);

export default SkipReasonContext;
